module.exports = __webpack_public_path__ + "img/app-yourbeach-2020.ed70c430.png";